import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, WizardServiceLocator, DialogService, Identity } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { PageCall } from '@sdbn/tmc-common';
import { TerminalVisitorRegistration, TerminalVisitorRegistrationResult } from '../widgets/terminal/visitor-registration.model';

export class VisitorInstructionsFinishedController extends AbstractStepController {

    errorOccured = false;

    appServerAPI: AppServerAPI;

    constructor() {
        super();
        this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
    }

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {
    }

    public handleFlow(): FlowStepHandleResult {
        const result = new FlowStepHandleResult();
        result.type = HandleResultType.PROCESSING;

        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('instructions finished started');

        this.saveInstructionResult();

        return result;
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();
        return controls;
    }


    private saveInstructionResult() {
        const dto = new TerminalVisitorRegistration();
        // Terminal identifier setzen
        dto.terminalIdentifier = this.dashboardContext.getContextValue('terminalIdentifier');
        dto.name = this.dashboardContext.getContextValue(TerminalContextConstants.lastname);
        dto.firstname = this.dashboardContext.getContextValue(TerminalContextConstants.firstname);
        dto.company = this.dashboardContext.getContextValue(TerminalContextConstants.company);
        dto.numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
        dto.reason = this.dashboardContext.getContextValue(TerminalContextConstants.reasonForVisit);
        dto.visitedPerson = this.dashboardContext.getContextValue(TerminalContextConstants.visitedPerson);
        dto.gcCaseId = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseId);
        dto.gcCaseUrl = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseUrl);
        dto.messagingLanguage = this.dashboardContext.getContextValue(TerminalContextConstants.language);
        dto.visitorType = this.dashboardContext.getContextValue('visitorType');

        const logContainer: LogContainer = this.dashboardContext.getContextValue(TerminalContextConstants.logContainer);

        for (const logEntry of logContainer.logEntries) {
            dto.pageCalls.push(new PageCall({ key: logEntry.message, timestamp: logEntry.timestamp }));
        }

        dto.registrationId = this.dashboardContext.getContextValue(TerminalContextConstants.registrationId);
        dto.registrationFinished = this.dashboardContext.getContextValue(TerminalContextConstants.registrationFinished);
        dto.registrationStarted = this.dashboardContext.getContextValue(TerminalContextConstants.registrationStarted);
        const driverCommunication = this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication);
        dto.smartphoneRequired = driverCommunication === TerminalContextConstants.DRIVER_COMMUNICATION_LOANER;
        const smartphoneConnected = this.dashboardContext.getContextValue(TerminalContextConstants.smartphoneConnected);
        dto.smartphoneConnected = smartphoneConnected == null || smartphoneConnected === true;
        dto.smartphoneCommunicationEnabled = this.dashboardContext.getContextValue('smartphoneConnectionEnabled') === true;
        dto.needsAreaAccess = this.dashboardContext.getContextValue('needsAreaAccess');

        const instructionTestResult = this.dashboardContext.getContextValue('instruction-test-result');
        dto.instructionTestResult = instructionTestResult == null ? null : instructionTestResult === true;
        const instrcutionTestErrorCount = this.dashboardContext.getContextValue('instruction-test-failure-count');
        dto.instructionTestFailureCount = instrcutionTestErrorCount == null ? 0 : instrcutionTestErrorCount;
        dto.sucessfullyFinishedInstructionTests = this.dashboardContext.getContextValue('sucessfully-finished-instruction-tests');


        this.appServerAPI.execute('/terminal/registration/visitor/save-instructions-result', dto)
            .toPromise()
            .then(response => {
                // We update the registrationId
                const terminalRegistrationResult = new TerminalVisitorRegistrationResult(response);
                this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, terminalRegistrationResult.registrationId);
                this.dashboardContext.setContextValue(TerminalContextConstants.lastname, terminalRegistrationResult.name);
                this.dashboardContext.setContextValue(TerminalContextConstants.firstname, terminalRegistrationResult.firstname);
                this.dashboardContext.setContextValue(TerminalContextConstants.company, terminalRegistrationResult.company);
                this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, terminalRegistrationResult.visitedPerson);
                this.dashboardContext.setContextValue('needsAreaAccess', terminalRegistrationResult.needsAreaAccess);
                this.dashboardContext.setContextValue(TerminalContextConstants.gatekeeperMandatory, terminalRegistrationResult.gatekeeperMandatory);
                this.dashboardContext.setContextValue(TerminalContextConstants.registrationCode, terminalRegistrationResult.registrationCode);
                this.dashboardContext.setContextValue(TerminalContextConstants.validity, terminalRegistrationResult.validity);
                this.dashboardContext.setContextValue('visitorType', terminalRegistrationResult.visitorType);
                this.wizardComponent.next();
            }, error => {
                console.log('saveMasterData call failed:', error);
                this.showHttpError();
            });
    }

    private showHttpError() {
        this.errorOccured = true;

        const matDialog = WizardServiceLocator.injector.get(DialogService);
        matDialog.showInfoDialog(
          'tmc-yard.widgets.registration-terminal.http.error.title',
          'tmc-yard.widgets.registration-terminal.http.error.message',
        ).afterClosed().subscribe(
            () => this.wizardComponent.restartWizard()
        );
    }
}
